export default __webpack_public_path__ + "static/media/logo2.79203c35.svg";